
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getRecycleProjectList, getProjectTaskCollect, projectReallyDelete, projectRecover } from '@/api/project';

@Component({
  name: 'ProjectRecycle',
  components: {

  }
})
export default class extends Vue {
  private tableData: any = []

  private projectAlias=(UserModule.getCompany.project_alias ? UserModule.getCompany.project_alias : '项目')
  private projectTaskAlias=(UserModule.getCompany.project_task_alias ? UserModule.getCompany.project_task_alias : '任务')
  private projectTaskCollectAlias=(UserModule.getCompany.project_task_collect_alias ? UserModule.getCompany.project_task_collect_alias : '任务集')

  // 页码处理
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  created() {
    this.getList();
  }
  private maps:any = new Map();
  private load(tree: any, treeNode: any, resolve: any) {
    if (parseInt(tree.is_project) === 1) {
      this.getTaskList(tree.id, '', tree, resolve);
      this.maps.set('-1', { tree, treeNode, resolve });
    } else {
      this.maps.set(tree.id, { tree, treeNode, resolve });
      this.getTaskList(tree.project_id, tree.id, tree, resolve);
    }
  }
  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }
  private getList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    getRecycleProjectList(pamars).then((res:any) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
        this.tableData.forEach((item:any) => {
          item.hasChildren = parseInt(item.child_number) > 0;
          item.onlyId = 'p' + item.id;
          item.hasOperation = true;
        });
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;

      this.tableData = [];
    });
  }
  private getTaskList(projectId:string, projectTaskId:string, tree:any, resolve:any) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = projectId;
    pamars.project_task_id = projectTaskId;
    pamars.is_recycle = 1;
    pamars.size = 999;
    pamars.is_pass_task = 1;
    getProjectTaskCollect(pamars).then((res:any) => {
      if (res.data) {
        let dataTable:any = res.data.list;
        tree.children = dataTable;
        dataTable.forEach((item:any) => {
          item.hasChildren = parseInt(item.child_number) > 0;
          item.onlyId = item.id;
          item.hasOperation = false;
        });
        resolve(dataTable);
      } else {
        resolve([]);
      }
    }).catch(err => {
      let msg = err.msg;
      resolve([]);
    });
  }

  private del(val:any) {
    let that = this;
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let pamars:any = {};
        pamars.user_id = UserModule.getUserId;
        pamars.user_name = UserModule.getUserName;
        pamars.company_id = UserModule.getCompanyId;
        pamars.project_id = val.id;
        projectReallyDelete(pamars).then((res:any) => {
          that.showSuccessMsg(res.msg);
          that.getList();
        }).catch(err => {
          that.showErrorMsg(err.msg);
        });
      });
  }
  private recover(val:any) {
    let that = this;
    this.$confirm('是否恢复项目?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let pamars:any = {};
        pamars.user_id = UserModule.getUserId;
        pamars.user_name = UserModule.getUserName;
        pamars.company_id = UserModule.getCompanyId;
        pamars.project_id = val.id;
        projectRecover(pamars).then((res:any) => {
          that.showSuccessMsg(res.msg);
          that.getList();
        }).catch(err => {
          that.showErrorMsg(err.msg);
        });
      });
  }

  private refDataList(pids:any, hasChildren:boolean) {
    let list = pids.split(',');
    let _ = this;
    if (list) {
      if (hasChildren) {
        _.refData(list[list.length - 1]);
      } else {
        _.refData(list[list.length - 1]);
        _.refData(list[list.length - 2]);
      }
    }
  }
  private refData(pid:any) {
    if (parseInt(pid) === -1) {
      this.maps.forEach((item:any) => {
        this.load(item.tree, item.treeNode, item.resolve);
      });
    } else {
      if (this.maps.get(pid)) {
        this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, pid, []);
        const { tree, treeNode, resolve } = this.maps.get(pid);
        this.load(tree, treeNode, resolve);
      }
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
